import { CampaignModel } from '@pukka/api';

const activeCampaigns = [
  {
    id: 1,
    name: 'Campaign 1',
    duration: Math.ceil(Math.random() * 10),
    start_date: '2023-04-22T06:50:45.865Z',
    end_date: null,
    outlet_ids: [614207],
    is_active: true,
    images: [
      {
        id: 1,
        name: 'campaign1.jpg',
        url: 'http://placekitten.com/200/300',
      },
    ],
  },
  {
    id: 4,
    name: 'Campaign 4',
    duration: Math.ceil(Math.random() * 10),
    start_date: '2023-04-22T06:50:45.865Z',
    end_date: '2030-04-22T06:50:45.865Z',
    outlet_ids: [614207],
    is_active: true,
    images: [
      {
        id: 1,
        name: 'campaign1.jpg',
        url: 'http://placekitten.com/200/300',
      },
    ],
  },
];

const inactiveCampaigns = [
  {
    id: 2,
    name: 'Campaign 2',
    duration: Math.ceil(Math.random() * 10),
    start_date: '2023-01-22T06:50:45.865Z',
    end_date: '2023-02-22T06:50:45.865Z',
    outlet_ids: [614207],
    is_active: false,
    images: [
      {
        id: 2,
        name: 'campaign2.jpg',
        url: 'http://placekitten.com/200/300',
      },
    ],
  },
  {
    id: 5,
    name: 'Campaign 5',
    duration: Math.ceil(Math.random() * 10),
    start_date: '2023-01-22T06:50:45.865Z',
    end_date: null,
    outlet_ids: [614207],
    is_active: false,
    images: [
      {
        id: 2,
        name: 'campaign2.jpg',
        url: 'http://placekitten.com/200/300',
      },
    ],
  },
  {
    id: 6,
    name: 'Campaign 6',
    duration: Math.ceil(Math.random() * 10),
    start_date: '2023-01-22T06:50:45.865Z',
    end_date: '2030-01-22T06:50:45.865Z',
    outlet_ids: [614207],
    is_active: false,
    images: [
      {
        id: 2,
        name: 'campaign2.jpg',
        url: 'http://placekitten.com/200/300',
      },
    ],
  },
];

const scheduledCampaigns = [
  {
    id: 3,
    name: 'Campaign 3',
    duration: Math.ceil(Math.random() * 10),
    start_date: '2030-01-15T06:50:45.865Z',
    end_date: null,
    outlet_ids: [614207],
    is_active: true,
    images: [
      {
        id: 3,
        name: 'campaign3.jpg',
        url: 'http://placekitten.com/200/300',
      },
    ],
  },
];

const campaignListByStatus: Record<CampaignModel.Status, CampaignModel.List> = {
  inactive: inactiveCampaigns,
  scheduled: scheduledCampaigns,
  active: activeCampaigns,
};

// single outlet
const campaignList: CampaignModel.List = [...activeCampaigns, ...inactiveCampaigns, ...scheduledCampaigns];

// multi outlets
const campaignList2 = [
  {
    id: 1,
    name: 'DO NOT MODIFY EDIT',
    duration: Math.ceil(Math.random() * 10),
    start_date: '2023-04-22T06:50:45.865Z',
    end_date: null,
    outlet_ids: [614218],
    is_active: true,
    images: [
      {
        id: 1,
        name: 'campaign1.jpg',
        url: 'http://placekitten.com/200/300',
      },
    ],
  },
  {
    id: 2,
    name: 'DO NOT MODIFY NO PERIOD',
    duration: Math.ceil(Math.random() * 10),
    start_date: '2023-04-22T06:50:45.865Z',
    end_date: null,
    outlet_ids: [614218],
    is_active: true,
    images: [
      {
        id: 1,
        name: 'campaign1.jpg',
        url: 'http://placekitten.com/200/300',
      },
    ],
  },
  {
    id: 65,
    name: 'WITH PERIOD DO NOT MODIFY',
    duration: 1,
    start_date: '2023-01-15T06:50:45.865Z',
    end_date: '2030-01-15T06:50:45.865Z',
    outlet_ids: [614217],
    is_active: true,
    images: [
      {
        id: 3,
        name: 'campaign3.jpg',
        url: 'http://placekitten.com/200/300',
      },
    ],
  },
  {
    id: 21,
    name: 'DO NOT MODIFY NO PERIOD',
    duration: Math.ceil(Math.random() * 10),
    start_date: '2023-04-22T06:50:45.865Z',
    end_date: null,
    outlet_ids: [614218],
    is_active: false,
    images: [
      {
        id: 1,
        name: 'campaign1.jpg',
        url: 'http://placekitten.com/200/300',
      },
    ],
  },
  {
    id: 3,
    name: 'Campaign 2',
    duration: Math.ceil(Math.random() * 10),
    start_date: '2023-01-22T06:50:45.865Z',
    end_date: '2023-02-22T06:50:45.865Z',
    outlet_ids: [614218],
    is_active: false,
    images: [
      {
        id: 2,
        name: 'campaign2.jpg',
        url: 'http://placekitten.com/200/300',
      },
    ],
  },
  {
    id: 41,
    name: 'DO NOT MODIFY PERIOD',
    duration: Math.ceil(Math.random() * 10),
    start_date: '2030-01-15T06:50:45.865Z',
    end_date: '2030-01-16T06:50:45.865Z',
    outlet_ids: [614218],
    is_active: false,
    images: [
      {
        id: 3,
        name: 'campaign3.jpg',
        url: 'http://placekitten.com/200/300',
      },
    ],
  },
  {
    id: 76,
    name: 'E2E DO NOT MODIFY',
    duration: Math.ceil(Math.random() * 10),
    start_date: '2030-01-15T06:50:45.865Z',
    end_date: null,
    outlet_ids: [614217],
    is_active: false,
    images: [
      {
        id: 3,
        name: 'campaign3.jpg',
        url: 'http://placekitten.com/200/300',
      },
    ],
  },
  {
    id: 4,
    name: 'DO NOT MODIFY PERIOD',
    duration: Math.ceil(Math.random() * 10),
    start_date: '2030-01-15T06:50:45.865Z',
    end_date: '2030-01-16T06:50:45.865Z',
    outlet_ids: [614218],
    is_active: true,
    images: [
      {
        id: 3,
        name: 'campaign3.jpg',
        url: 'http://placekitten.com/200/300',
      },
    ],
  },
  {
    id: 45,
    name: 'WO PERIOD DO NOT MODIFY',
    duration: Math.ceil(Math.random() * 10),
    start_date: '2030-01-15T06:50:45.865Z',
    end_date: null,
    outlet_ids: [614217],
    is_active: true,
    images: [
      {
        id: 3,
        name: 'campaign3.jpg',
        url: 'http://placekitten.com/200/300',
      },
    ],
  },
  {
    id: 75,
    name: 'E2E DO NOT MODIFY',
    duration: 1,
    start_date: '2030-01-15T06:50:45.865Z',
    end_date: null,
    outlet_ids: [614217],
    is_active: true,
    images: [
      {
        id: 3,
        name: 'campaign3.jpg',
        url: 'http://placekitten.com/200/300',
      },
    ],
  },
];

const campaignListByStatus2: Record<CampaignModel.Status, CampaignModel.List> = {
  active: campaignList2.slice(0, 3), // 0-2
  inactive: campaignList2.slice(3, 7), // 3-6
  scheduled: campaignList2.slice(7), // 7-end
};

export { campaignList, campaignListByStatus, campaignList2, campaignListByStatus2 };
